/**
 * Pont entre l'appli UpCart et le thème (fiche produit).
 * UpCart prend la main sur « Ajouter au panier » : il ignore les cases à cocher du cross-sell
 * (_toggle-cross-sell) et le thème n'est pas prévenu de ses ajouts (bulle du panier figée).
 * 1. Produit(s) coché(s), quel que soit l'upsell : on ajoute d'abord ces articles, puis on relance le clic pour UpCart,
 *    dont le tiroir affiche alors tout le panier.
 * 2. Après chaque modification du panier, la bulle du thème est remise au bon nombre.
 * 3. Variante : le formulaire contient deux champs « id » (sélecteur de variante + champ de secours du bouton,
 *    jamais mis à jour). UpCart garde le dernier, donc l'ancienne variante : on les aligne sur la variante choisie.
 * Sans UpCart, rien ne se passe : le thème gère lui-même le cross-sell.
 */
(() => {
  if (window.cfUpcartBridge) return;
  window.cfUpcartBridge = true;

  const hasUpcart = () => Boolean(window.upcart || document.querySelector('script[src*="upcart-bundle"]'));
  let passThrough = false;
  let busy = false;

  // Le champ du sélecteur de variante fait foi (c'est aussi celui que lit le thème)
  function syncVariantIds(form) {
    if (!form) return;
    const inputs = form.querySelectorAll('input[name="id"]');
    const current = form.querySelector('variant-picker input[name="id"]') || inputs[0];
    if (!current) return;
    inputs.forEach((input) => {
      if (input.value !== current.value) input.value = current.value;
    });
  }

  document.addEventListener('variant:updated', (event) => {
    syncVariantIds(event.target.closest?.('form'));
  });

  // Tous les produits cochés du cross-sell, en mode « case à cocher » comme en mode « bouton »
  function checkedCrossSells(form) {
    if (!form) return [];
    const selected = [
      ...form.querySelectorAll('[data-ref="toggle-cross-sell-checkbox"]:checked'),
      ...form.querySelectorAll('[data-ref="toggle-cross-sell-button"].button--active'),
    ];
    return selected.map((el) => ({ id: Number(el.dataset.variantId), quantity: 1 })).filter((item) => item.id);
  }

  window.addEventListener('click', (event) => {
    if (passThrough || !hasUpcart()) return;
    const button = event.target.closest?.('.product-form__form [name="add"], .product-form__form button[type="submit"]');
    if (!button || button.disabled) return;
    syncVariantIds(button.form || button.closest('form'));
    const items = checkedCrossSells(button.form || button.closest('form'));
    if (!items.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    })
      .catch(() => {}) // Pendule indisponible : on ajoute quand même le produit principal
      .finally(() => {
        busy = false;
        passThrough = true;
        try {
          button.click();
        } finally {
          passThrough = false;
        }
      });
  }, true);

  // Bulle du panier : recalée sur le vrai panier après chaque ajout / modification
  let timer = null;
  function syncCount() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => {
          document.querySelectorAll('cart-icon [data-ref="cart-count"]').forEach((count) => {
            if (count.textContent.trim() !== String(cart.item_count)) count.textContent = cart.item_count;
          });
        })
        .catch(() => {});
    }, 300);
  }

  if ('PerformanceObserver' in window) {
    new PerformanceObserver((list) => {
      if (list.getEntries().some((entry) => /\/cart\/(add|change|update|clear)/.test(entry.name))) syncCount();
    }).observe({ type: 'resource', buffered: false });
  }
})();
